import { render, staticRenderFns } from "./changePasswordSuccess.vue?vue&type=template&id=2af9cf7a&"
import script from "./changePasswordSuccess.vue?vue&type=script&lang=ts&"
export * from "./changePasswordSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./changePasswordSuccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports